export default class MobileNavigation {
    constructor() {
        const categories = document.querySelectorAll('#mobileMenu .product-category');
        categories.forEach(category => category.addEventListener('click', this.toggle));
    }

    toggle(e) {
        e.preventDefault();
        const category = e.target.closest('li');
        let canvasBody = document.querySelectorAll('.offcanvas-body')[0];
        
        let menuIsOpen = category.classList.contains('open');
        
        if(!menuIsOpen) {
            category.classList.add('open');
            canvasBody.classList.add("offcanvas-body__no-scroll");
        }
        else{
            category.classList.remove('open');
            canvasBody.classList.remove("offcanvas-body__no-scroll");
        }
    }
}